import { FC } from "react"
import { Logout } from "../../../module/users/containers/logout"

export const LogoutPage: FC = () => <Logout />
